import { combineEpics } from 'redux-observable'
import { createInvokeEpic } from '../../signalr/createInvokeEpic'
import { createStreamEpic } from '../../signalr/createStreamEpic'
import {
  fetchUserPreferencesDefinition,
  saveUserPreferencesDefinition
} from './definition'

export default combineEpics(
  createStreamEpic(
    'userPreferences.fetchUserPreferences',
    fetchUserPreferencesDefinition
  ),
  createInvokeEpic(
    'userPreferences.setUserPreferences',
    saveUserPreferencesDefinition
  )
)
